module.exports = __webpack_public_path__ + "img/exclamation-mark.53478c7d.svg";